module.exports = __webpack_public_path__ + "static/media/loading.47524518.gif";